import { FC, useState } from 'react';

import { push } from 'connected-react-router';
import { BANNER_IMAGE_CROP_DEFAULT } from 'utils/constants/banner';

import { ActionBar, Button, useBreakpoint } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';
import { useDashboardRoute } from 'hooks/useDashboardRoute';

import { validateAndSaveBanner } from 'components/BannerBuilder/BannerBuilderActions/validateAndSaveBanner';

import { setIsGalleryModalVisible } from 'store/models/gallery';
import { useDispatch, useSelector } from 'store/utils';

const TrlKeys = {
    save: 'BannerCreate.BannerForm.Buttons.save',
    back: 'BannerCreate.BannerForm.Buttons.back',
};

export const BannerBuilderActions: FC = () => {
    const [isSaving, setSaving] = useState(false);

    const images = useSelector((state) => state.createBanner.images);
    const isVideoLoading = useSelector((state) => state.createBanner.isVideoLoading);

    const dispatch = useDispatch();
    const trls = useTrls();
    const { isMobile } = useBreakpoint();
    const dashboardRoute = useDashboardRoute();

    return (
        <ActionBar
            showDivider="always"
            type={isMobile ? 'vertical' : 'horizontal'}
            isSticky
            primaryActions={
                <Button
                    data-qa="save-banner-button"
                    disabled={isVideoLoading}
                    loading={isSaving}
                    mode="primary"
                    style="accent"
                    onClick={() => {
                        if (!images[BANNER_IMAGE_CROP_DEFAULT].id) {
                            dispatch(setIsGalleryModalVisible(true));
                        } else {
                            void dispatch(validateAndSaveBanner(setSaving, dashboardRoute));
                        }
                    }}
                >
                    {trls(TrlKeys.save)}
                </Button>
            }
            secondaryActions={
                <Button
                    onClick={() => dispatch(push(dashboardRoute))}
                    data-qa="back-to-dashboard-button"
                    mode="secondary"
                    style="accent"
                >
                    {trls(TrlKeys.back)}
                </Button>
            }
        />
    );
};
